import { render } from "./CatalogProductInsertPage.vue?vue&type=template&id=288cc3e0"
import script from "./CatalogProductInsertPage.vue?vue&type=script&lang=js"
export * from "./CatalogProductInsertPage.vue?vue&type=script&lang=js"

import "@/assets/scss/hezabat.scss?vue&type=style&index=0&lang=scss"
import "@/assets/scss/policy-detail.scss?vue&type=style&index=1&lang=scss"

import exportComponent from "C:\\Users\\Rufiz Huseynzada\\OneDrive - Azerbaijan State Oil and Industry University\\Desktop\\ProgressProjects\\AgentModule\\web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__